// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { USER_MODULE, USER_URL, USER_DETAIL_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { ProfileIndex, CompanyIndex, MyDocumentIndex, AdditionalQuestionindex } = lazily(() => import('pages/back-office/user/user-detail'))
const { BackOfficeUserDetailCard } = lazily(() => import('components/back-office/BackOfficeUserDetailCard'))

const userDetailRoutes: IRoute[] = [
  {
    path: `${USER_URL.USER_DETAIL}/:userId/profile`,
    component: ProfileIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: USER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'backOffice.profileData',
        accessCodes: [442],
        noBackOfficeCard: false,
        optionalModule: USER_DETAIL_MODULE,
        customBackOfficeCard: BackOfficeUserDetailCard
      },
    },
  },
  {
    path: `${USER_URL.USER_DETAIL}/:userId/company`,
    component: CompanyIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: USER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'backOffice.companyData',
        accessCodes: [442],
        noBackOfficeCard: false,
        optionalModule: USER_DETAIL_MODULE,
        customBackOfficeCard: BackOfficeUserDetailCard
      },
    },
  },
  {
    path: `${USER_URL.USER_DETAIL}/:userId/additional-question`,
    component: AdditionalQuestionindex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: USER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'backOffice.additionalQuestion',
        accessCodes: [442],
        noBackOfficeCard: false,
        optionalModule: USER_DETAIL_MODULE,
        customBackOfficeCard: BackOfficeUserDetailCard
      },
    },
  },
  {
    path: `${USER_URL.USER_DETAIL}/:userId/my-document`,
    component: MyDocumentIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: USER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'backOffice.myDocument',
        accessCodes: [442],
        noBackOfficeCard: false,
        optionalModule: USER_DETAIL_MODULE,
        customBackOfficeCard: BackOfficeUserDetailCard
      },
    },
  },
]

export { userDetailRoutes }
